import { FastField } from "formik"
import { TextField } from "formik-material-ui"
import React from "react"

export const FirstNameField = (props: any) => {
  return (
    <FastField
      style={{
        width: "100%",
      }}
      component={TextField}
      id="info.firstName"
      name="info.firstName"
      type="text"
      label="Meno"
    ></FastField>
  )
}
